import { formatDateTR } from "@/lib/format";

export function downloadCSV(rows, columns, filename) {
  const escape = (v) => {
    if (v === null || v === undefined) return "";
    const s = String(v);
    if (s.includes(",") || s.includes('"') || s.includes("\n")) {
      return `"${s.replace(/"/g, '""')}"`;
    }
    return s;
  };
  const header = columns.map((c) => escape(c.label)).join(",");
  const body = rows
    .map((r) => columns.map((c) => escape(c.get ? c.get(r) : r[c.key])).join(","))
    .join("\n");
  const csv = "\ufeff" + header + "\n" + body; // BOM for Turkish chars in Excel
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export const fmtDate = (v) => (v ? formatDateTR(v) : "");
export const fmtNum = (v) => (v != null ? String(v).replace(".", ",") : "");
